var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlagReg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "1s9eqq3pza",
    d: "M23.667 9L23 6 8 6 8 34 11 34 11 22 20.667 22 21.333 25 33 25 33 9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-936 -187) translate(529) translate(191 187) translate(216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qwgc99bhkb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1s9eqq3pza"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CB0000",
    mask: "url(#qwgc99bhkb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagReg);
export default __webpack_public_path__ + "static/media/icon-flag-reg.63ccdc18280225f66cd9dd925cc8ecf9.svg";
export { ForwardRef as ReactComponent };